import Repository from "../Repository"
const get_portfolio = "getPortfolio"
const add_portfolio = "addPortfolio"
const edit_portfolio = "editPortfolio"
const delete_portfolio="deletePortfolio"

export default {
    getportfolio(payload) {
        return Repository.post(transformRoute(get_portfolio), payload);
    },
    addportfolio(payload) {
        return Repository.post(transformRoute(add_portfolio), payload);
    },
    editportfolio(payload) {
        return Repository.post(transformRoute(edit_portfolio), payload);
    },
    deleteportfolio(payload) {
        return Repository.post(transformRoute(delete_portfolio), payload);
    },

}

const transformRoute = route => {
  return `/portfoliomgmt/${route}`;
};